import {addDays} from "date-fns";
import {inZone} from "./in-zone";

/**
 * @hidden
 */
export function addDaysInZone(date: Date, amount: number, zone: string): Date;

/**
 * @hidden
 */
export function addDaysInZone(date: undefined, amount: number, zone: string): undefined;

/**
 * @hidden
 */
export function addDaysInZone(date: null, amount: number, zone: string): null;

/**
 * @hidden
 */
export function addDaysInZone(date: Date | undefined, amount: number, zone: string): Date | undefined;

/**
 * @hidden
 */
export function addDaysInZone(date: Date | null, amount: number, zone: string): Date | null;

export function addDaysInZone(date: Date | undefined | null, amount: number, zone: string): Date | undefined | null;

/**
 * Adds days to the date in the specified zone. For example, if the zone is 'Pacific/Auckland' and the date is
 * '2022-04-03T11:00:00Z' (start of Sunday 3rd April 2022 in NZ) and we add a day then the result should be
 * '2022-04-04T12:00:00Z' (start of Monday 4th April 2022 in NZ)
 *
 * @param date
 * @param amount
 * @param zone the time zone descriptor, usually an offset or IANA time zone name (e.g. America/Los_Angeles)
 */
export function addDaysInZone(date: Date | undefined | null, amount: number, zone: string): Date | undefined | null {
  return inZone(zone, addDays, date, amount);
}
